'use client'

import { createContext, useContext, ReactNode } from 'react'

import type { InitialUserData } from '@/shared/lib/data/types'

interface DataContextValue {
  initialData: InitialUserData
  hasInitialData: boolean
  getInitialData: (path: string) => any | undefined
}

const DataContext = createContext<DataContextValue | null>(null)

export function useData(): DataContextValue {
  const ctx = useContext(DataContext)
  if (!ctx) {
    throw new Error('useData must be used within DataProvider')
  }
  return ctx
}

interface DataProviderProps {
  children: ReactNode
  initialData: InitialUserData
}

export function DataProvider({ children, initialData }: DataProviderProps) {
  const hasInitialData = Object.keys(initialData).length > 0
  const getInitialData = (path: string) => {
    return initialData[path]
  }

  return (
    <DataContext.Provider
      value={{
        initialData,
        hasInitialData,
        getInitialData
      }}
    >
      {children}
    </DataContext.Provider>
  )
}
